import React from 'react';

const MarqueeSection = () => {
  return (
    <section className="marquee-section bg-primary text-white">
      <div className="marquee-inner">
        <span>LAVORO · SCUOLA · DIRITTI · AMBIENTE · SALUTE MENTALE · FORMAZIONE · </span>
        <span>LAVORO · SCUOLA · DIRITTI · AMBIENTE · SALUTE MENTALE · FORMAZIONE · </span>
      </div>
    </section>
  );
};

export default MarqueeSection;
